module.exports = __webpack_public_path__ + "images/delay.a478afc5c7c65ba11164081393349dda.png";